import dayjs, { extend } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayOfYear from "dayjs/plugin/dayOfYear";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import MinMax from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";

extend(utc);
extend(timezone);
extend(duration);
extend(relativeTime);
extend(MinMax);
extend(customParseFormat);
extend(dayOfYear);
extend(isoWeek);
extend(isBetween);
extend(advancedFormat);
extend(weekOfYear);
extend(isSameOrAfter);

export default dayjs;
